<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    export let branch = 'BHP';
    export let branchId = 1;
    export let execution = false;
    export let workCentreId = 0;
    export let workOrderAutomationEnabled = false;

	import { checked, labelWithCount } from './HomePage.svelte';
    import MainWorkCentreSelect from './MainWorkCentreSelect.svelte';

    import {sgettext} from '../../i18n.js';

    import AllScheduleInstances from './AllScheduleInstances.svelte';
    import InProgressInstances from './InProgressInstances.svelte';
    import ScheduledInstances from './ScheduledInstances.svelte';
    import ExecutedInstances from './ExecutedInstances.svelte';
    import ArchivedInstances from './ArchivedInstances.svelte';
    import FailedInstances from './FailedInstances.svelte';

    import LeftRightBox from './LeftRightBox.svelte';
    import Tabs from '../Tabs/Tabs.svelte';
    import Tab from '../Tabs/Tab.svelte';
    import TabPanel from '../Tabs/TabPanel.svelte';
    import TabBar from '../Tabs/TabBar.svelte';
    import {buildUrl} from '../../utils';
    import {
        dashBoardWorkCentreId,
    } from './dashBoardStrore.js';


    let stats = {};
    const fetchCounts = async (params) => {
        stats = await (await fetch(buildUrl(`${PATH_PREFIX}/sw/api/schedule_stats`, params))).json();
    }

    $: fetchCounts({branch: branchId, checked: $checked, workCentreId: $dashBoardWorkCentreId});

</script>

<Tabs className="subtabs" persistKey="homepage-schedule">
	<LeftRightBox>
		<label slot="left">{sgettext('$$SCHEDULE$$')}</label>
		<TabBar slot="right">
            {#if execution}
                <MainWorkCentreSelect
                    {branchId}
                    bind:value={workCentreId}
                />
            {/if}
			<Tab
				key="all"
				label={sgettext('$$ALL$$') + (stats.total != null ? ` (${stats.total})` : '')}
				component={AllScheduleInstances}
				{branchId}
				{branch}
			/>

            {#if workOrderAutomationEnabled}
                <Tab
                    key="failed"
                    label={sgettext('$$FAILED$$') + (stats.failed != null ? ` (${stats.failed})` : '')}
                    component={FailedInstances}
                    {branchId}
                    {branch}
                />
            {/if}
			<Tab
				key="progress"
				label={sgettext('$$PROGRESS_1$$') + (stats.in_progress != null ? ` (${stats.in_progress})` : '')}
				component={InProgressInstances}
				{branchId}
				{branch}
			/>
			<Tab
				key="scheduled"
				label={sgettext('$$SCHEDULED$$') + (stats.scheduled != null ? ` (${stats.scheduled})` : '')}
				component={ScheduledInstances}
				{branchId}
				{branch}
			/>
			<Tab
				key="executed"
				label={sgettext('$$EXECUTED$$') + (stats.executed != null ? ` (${stats.executed})` : '')}
				component={ExecutedInstances}
				{branchId}
				{branch}
			/>
			<Tab
				key="archived"
				label={sgettext('$$ARCHIVED$$') + (stats.archived != null ? ` (${stats.archived})` : '')}
				component={ArchivedInstances}
				{branchId}
				{branch}
			/>
		</TabBar>
	</LeftRightBox>
	<TabPanel />
</Tabs>
